<template>
  <div id="app">
    <router-view v-if="$route.meta.fullscreen"></router-view>
    <Layout v-else>
      <template slot="aside">
        <MenuNav :datasource="navList" :default-active="defaultActive"></MenuNav>
      </template>
      <template slot="header">
        <MainHeader></MainHeader>
      </template>
      <template slot="main">
        <!-- 这里是会被缓存的视图组件，比如-->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 这里是不被缓存的视图组件，比如 List！-->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </template>
    </Layout>
  </div>
</template>
<script>
import * as R from 'ramda';
import {mapGetters, mapState} from 'vuex';

import {Layout, MainHeader, MenuNav} from '@/comp';

export default {
  name: 'app',
  data() {
    return {
      env: process.env.NODE_ENV,
      userName: '',
    };
  },
  methods: {
    quitSystem() {
      this.$confirm('确认退出吗?', '提示', {}).then(() => {
      }).catch(console.log);
    },
  },
  computed: {
    ...mapState('common', ['userInfo']),
    ...mapGetters('rbac', ['navList']),
    defaultActive() {
      return this.$route.path;
    },
  },
  components: {
    Layout,
    MenuNav,
    MainHeader,
  },
  created() {
    if (!R.is(Object, this.userInfo) && this.$route.name !== 'Login') { // 登录失效
      this.$router.push({name: 'Login'});
    }
  },
};
</script>
<style lang="scss">
.detailDrawer{
  background-color: rgb(33, 39, 49) !important;
}
#app {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  // color: #4c4c4c;

  .navbar {
    padding-right: 20px;

    .navbar-name {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 300;

      .link {
        color: #fff;
      }
    }

    .header-right {
      display: flex;

      .user-name {
        font-size: 17px;
        color: #fff;
      }

      .log-out {
        font-size: 16px;
        color: red;
        cursor: pointer;
        padding-top: 2px;
      }
    }
  }

  .page {
    width: 100%;
    height: 100%;
  }

  .el-container {
    overflow: auto;
  }

  .tree-icon {
    width: 26px;
    height: 26px;
  }

  .page-container {
    position: relative;
    min-height: 100%;

    &.main {
      background-color: #212731;
      // padding: 16px;
    }

    .filter-container {
      background-color: #212731;
      min-height: 64px;
      padding-left: 16px;

      .el-form {
        margin: 0;
        padding-top: 16px;

        &.el-form--inline {
          .el-form-item {
            margin-right: 32px;
          }
        }
      }

      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__content {
          .el-input--small {
            width: 144px;
          }

          .el-range-editor {
            width: 368px;
          }
        }
      }

      .btn-container {
        display: inline-block;
        margin-bottom: 16px;
      }
    }

    .table-container {
      background-color: #fff;
      // padding: 16px;
      padding-top: 0;
    }

    .form {
      .el-input {
        max-width: 216px;
      }

      .el-textarea__inner {
        font-size: 14px;
        color: #8993A6;
        max-width: 600px;
        //min-height: 144px !important;
        border: 1px solid #35404E;
      }

      .is-error {
        .el-textarea__inner {
          border-color: #f56c6c;
        }
      }
    }
  }
}

.el-form {
  margin-top: 16px;

  .el-form-item {
    margin-bottom: 16px !important;

    &.is-error {
      .el-input {
        .el-input__inner {
          border-color: #f56c6c;
        }
      }
    }

    &.textarea {
      .el-form-item__label {
        line-height: 16px;
        margin-top: 4px;
      }
    }

    &.file-list {
      .el-form-item__content {
        display: flex;
      }
    }

    .el-input {
      &.readonly {
        .el-input__inner {
          background-color: #2B323D;
          color: #E3EAF7;
          border: none;
        }
      }

      .el-input__inner {
        font-size: 14px;
        background-color: #282F3A;
        border: 1px solid #35404E;
      }
    }

    .el-cascader__search-input {
      background-color: #282f3a;
      color: #E3EAF7;
      border: none;
    }
  }
}

/*.back-button {*/
/*  position: fixed;*/
/*  top: 16px;*/
/*  left: 200px;*/
/*  background-color: rgba(221,236,255,0.1);*/
/*  border: none;*/
/*  border-radius: 4px;*/
/*  width: 32px;*/
/*  height: 32px;*/
/*  padding: 0px;*/
/*  background-image: url('~@/assets/backto.png');*/
/*}*/

.el-cascader-node__label {
  color: rgba(202, 211, 230, 1);
}

.el-cascader-node:not(.is-disabled):hover, .el-cascader-node:not(.is-disabled):focus {
  background: #3F4758 !important;
}

.el-cascader-menu {
  background-color: #282F3A;
}

.el-cascader__dropdown {
  border: 1px solid rgba(53, 64, 78, 1);
}

.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #35404E;
}

.el-autocomplete-suggestion.el-popper {
  width: auto !important;
}

// 全局Notification使用的容器样式
.global-notification {
  // 解决英文不自动换行的问题
  .el-notification__content {
    width: 276px;
    word-wrap: break-word;
    text-align: left;
  }
}

.el-pagination {
  background-color: #222933;
  margin-top: -1px;
  position: relative;
  z-index: 1;

  .btn-next {
    border: 1px solid #35404E;
    border-radius: 4px;
    padding: 0 6px;
  }

  .btn-prev {
    border: 1px solid #35404E;
    border-radius: 4px;
    padding: 0 6px;
  }
}

/* =============标准化全局样式 ===============*/
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  /* -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; */
  font-weight: 300;

  transition: all 0s linear;
}

html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app,
#appInner {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}

table {
  border: 0;
  margin: 0;
  border-collapse: collapse;
  border-spacing: 0;
  vertical-align: middle;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  line-height: 150%;
}

a:link,
a:visited,
a:active,
a:hover,
a:focus {
  text-decoration: none;

}

a:link,
a:visited,
a:focus {
  color: #6da2f4;
}

a:hover,
a:active {
  color: #4d8df1;
}

input:active,
input:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

input[disabled],
select[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}

.el-table--small {
  font-size: 14px;

  td {
    padding: 0 !important;
    border: none;
    height: 48px;
  }

  th {
    padding: 0 !important;
    border: none !important;
    height: 40px;
    background-color: #31394A;
  }

  tr {
    background-color: #242B36;
  }
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #212731;
}

.el-pagination {
  display: flex;
  justify-content: center;
  height: 48px;
  align-items: center;

  span:not([class*=suffix]) {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue